var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89388 14.1533C7.57171 14.1533 7.31055 14.4145 7.31055 14.7367V42.7367C7.31055 43.0588 7.57171 43.32 7.89388 43.32H49.8939C50.216 43.32 50.4772 43.0588 50.4772 42.7367V14.7367C50.4772 14.4145 50.216 14.1533 49.8939 14.1533H7.89388ZM3.81055 14.7367C3.81055 12.4815 5.63872 10.6533 7.89388 10.6533H49.8939C52.149 10.6533 53.9772 12.4815 53.9772 14.7367V42.7367C53.9772 44.9918 52.149 46.82 49.8939 46.82H7.89388C5.63872 46.82 3.81055 44.9918 3.81055 42.7367V14.7367Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81055 24.07C3.81055 23.1035 4.59405 22.32 5.56055 22.32H52.2272C53.1937 22.32 53.9772 23.1035 53.9772 24.07C53.9772 25.0365 53.1937 25.82 52.2272 25.82H5.56055C4.59405 25.82 3.81055 25.0365 3.81055 24.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56055 18.82C6.52705 18.82 7.31055 19.6035 7.31055 20.57V27.57C7.31055 28.5365 6.52705 29.32 5.56055 29.32C4.59405 29.32 3.81055 28.5365 3.81055 27.57V20.57C3.81055 19.6035 4.59405 18.82 5.56055 18.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2272 18.82C53.1937 18.82 53.9772 19.6035 53.9772 20.57V27.57C53.9772 28.5365 53.1937 29.32 52.2272 29.32C51.2607 29.32 50.4772 28.5365 50.4772 27.57V20.57C50.4772 19.6035 51.2607 18.82 52.2272 18.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9772 34.57C32.9772 33.6035 33.7607 32.82 34.7272 32.82H44.0606C45.0271 32.82 45.8106 33.6035 45.8106 34.57C45.8106 35.5365 45.0271 36.32 44.0606 36.32H34.7272C33.7607 36.32 32.9772 35.5365 32.9772 34.57Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank-transfer.582c8674.svg";
export { ForwardRef as ReactComponent };